import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';
import { BookingReportTemplate } from '../booking-report-template';

@Component({
  selector: 'app-pdf-templates-booking-related',
  templateUrl: './pdf-templates-booking-related.component.html',
  styleUrls: ['./pdf-templates-booking-related.component.css']
})
export class PdfTemplatesBookingRelatedComponent implements OnInit {

  constructor(
    public pdfTemplateService: PdfDocumentTemplateService,
    private httpService: HttpService,
    private confirmationService: ConfirmationService,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.httpService.getPdfDocumentTemplatesByLanguageId(this.pdfTemplateService.selectedLanguage.id).subscribe(res => {
      this.pdfTemplateService.bookingPdftemplates = res;
    });
  }

  editSelectedBookingPdfTemplate(template: BookingReportTemplate){
    this.pdfTemplateService.selectedBookingPdfTemplate = template;
    this.pdfTemplateService.activeItemId = PdfTemplateViewOption.EDIT_BOOKING_RELATED;
  }

  deleteTemplate(templateId: number){
    this.confirmationService.confirm({
      message: "Do you waint to delete the template id: " + templateId + "?",
      accept: () => {
        this.httpService.deleteBookingReportTemplate(templateId).subscribe(() => {
          this.removeTemplateFromArray(templateId);
          this.toastService.addSuccess("Success", "Template deleted");
        }, error => this.toastService.addError("Error", "Template could not be deleted"));
      }
    });
  }

  removeTemplateFromArray(templateId: number){
    const templates = this.pdfTemplateService.bookingPdftemplates;
    for(let template of templates){
      if(template.id == templateId){
        const index = templates.indexOf(template);
        templates.splice(index, 1);
      }
    }
  }

}
